export default class DocumentResource {
    public constructor(
        private readonly id: string,
        private readonly resourceId: number,
        private readonly documentReference: number
    ) {}

    public getId(): string {
        return this.id;
    }

    public getResourceId(): number {
        return this.resourceId;
    }

    public getDocumentReference(): number {
        return this.documentReference;
    }
}